// extracted by css-extract-rspack-plugin
export default {"cls1":"SourcePaperCard-cls1_2Ff","cls2":"SourcePaperCard-cls2_o4G SourcePaperCard-cls1_2Ff"};